import { PropsWithChildren, useCallback } from "react";
import * as XLSX from 'xlsx';

import Button from "../themed/button";


interface Props<T> extends PropsWithChildren{
    data: T[];
    fileName: string;
    label?: string;
}

const ExcelExport = <T extends unknown>({ data, children, fileName, label = 'Export to Excel '}: Props<T>) => {
    const handleDataExportToExcel = useCallback(() => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(data);

        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, fileName + ".xlsx");
    }, [data, fileName]);

    return ( 
        <div>
            <div className="d-flex mb-2 justify-content-end">
                <Button
                    icon="file-earmark-spreadsheet"
                    label={label}
                    style={{ backgroundColor: "#004e2a" }}
                    onClick={handleDataExportToExcel}
                />
            </div>

            {children}
        </div>
    );
};
 
export default ExcelExport;